// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1tMqm","content":"styles_content__3DLfS","textInputWidthDefault":"styles_textInputWidthDefault__3zFFL","flexButton":"styles_flexButton__o7xci"};